import axiosInstance from "./AxiosInstanceMain";

export const getProjectFormRelationsApi = async (params) => {
  const res = await axiosInstance.get("/project-form-relation/getAll", { params });
  return res.data;
};

export const createProjectFormRelationApi = async (data) => {
  const res = await axiosInstance.post("/project-form-relation/create", data);
  return res.data;
};

export const updateProjectFormRelationApi = async (id, data) => {
  const res = await axiosInstance.put(`/project-form-relation/update/${id}`, data);
  return res.data;
};

export const toggleProjectFormRelationApi = async (id, data) => {
  const res = await axiosInstance.patch(`/project-form-relation/${id}/status`, data);
  return res.data;
};

export const deleteProjectFormRelationApi = async (id) => {
  const res = await axiosInstance.delete(`/project-form-relation/delete/${id}`);
  return res.data;
};

export const getProjectsHavingFormsApi= async()=>{
  const res= await axiosInstance.get( "/project-form-relation/projects-with-forms" );
  return res.data;
};